import type { BookingResponse } from '@/shared/api';
import { formatMoney } from './format';

export const PRICE_UNDER_REVIEW = 'Preis wird geprüft';

type BookingPrice = Pick<
  BookingResponse,
  'totalPrice' | 'grandTotal' | 'currency' | 'priceEvidenceState'
> & {
  source?: BookingResponse['source'];
};

export function isPriceUnderReview(booking: BookingPrice): boolean {
  return booking.totalPrice === null || (booking.priceEvidenceState ?? 'Known') !== 'Known';
}

export function formatAccommodationPrice(booking: BookingPrice): string {
  if (isPriceUnderReview(booking)) return PRICE_UNDER_REVIEW;
  return formatMoney(booking.totalPrice!, booking.currency);
}

export function formatBookingPrice(booking: BookingPrice): string {
  if (isPriceUnderReview(booking)) return PRICE_UNDER_REVIEW;
  return formatMoney(booking.grandTotal ?? booking.totalPrice!, booking.currency);
}
